import { dataFetcher } from 'core/services/requestHandler';   

const getAmenities = async (data = {}, config = {}) => {
  return dataFetcher('libraries/getAmenities', data, {...config});
};

const saveAmenity = async (data = {}, config = {}) => {
  return dataFetcher('libraries/saveAmenity', data, {...config});
};

const deleteAmenity = async (data = {}, config = {}) => {
  return dataFetcher('libraries/deleteAmenity', data, {...config});
};

export { getAmenities, saveAmenity, deleteAmenity };
